import React, { useState } from 'react';
import { Text } from '../text/index.js';
import { DropZoneInner, UploaderActionsContainer, } from './file-drop-zone.styles.js';
const hasFile = (types) => types.includes('Files');
export const FileDropZone = ({ isEnabled, hasError, dropZoneText, dataAutomation = 'file-drop-zone', children, onDrop, }) => {
    const [hasFileOver, setHasFileOver] = useState(false);
    return (React.createElement(React.Fragment, null, isEnabled ? (React.createElement(UploaderActionsContainer, { "data-automation": dataAutomation, "$hasError": hasError, "$hasFileOver": hasFileOver, onDragOver: (e) => e.preventDefault(), onDragEnter: (e) => {
            e.preventDefault();
            setHasFileOver(hasFile(e.dataTransfer.types));
        }, onDragLeave: (e) => {
            e.preventDefault();
            setHasFileOver(false);
        }, onDrop: (e) => {
            if (e.dataTransfer.files.length === 0) {
                return;
            }
            e.preventDefault();
            onDrop({
                files: Array.from(e.dataTransfer.files),
            });
            setHasFileOver(false);
        } },
        React.createElement(DropZoneInner, { align: 'center' },
            React.createElement(Text, { color: 'secondary', fontSize: 's', "data-automation": `${dataAutomation}/label` }, dropZoneText),
            children))) : (children)));
};
//# sourceMappingURL=file-drop-zone.js.map